export function parseOrUndefined(value: string) {
   const num = parseFloat(value);
   return isNaN(num) ? undefined : num;
}

export function groupBy(array: any[], size: number): any[] {
   const grouped = [];
   for (let i = 0; i < array.length; i += size) {
      grouped.push(array.slice(i, i + size));
   }
   return grouped;
}
